import { SvgIcon } from "@mui/material";

export default function UndoIcon({ ...restProps }) {
  return (
    <SvgIcon
      {...restProps}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      id="Undo"
    >
      <path fill="none" d="M0 0h24v24H0Z"></path>
      <path
        fill="#ffffff"
        d="M13.95 7.05H5.49L8.6 3.936a.9.9 0 0 0-1.269-1.272L2.664 7.331a.9.9 0 0 0 0 1.273l4.667 4.666A.9.9 0 0 0 8.6 12L5.456 8.85h8.494a5.645 5.645 0 0 1 5.85 5.4 5.645 5.645 0 0 1-5.85 5.4h-.9a.9.9 0 1 0 0 1.8h.9a7.444 7.444 0 0 0 7.65-7.2 7.444 7.444 0 0 0-7.65-7.2Z"
        className="color525863 svgShape"
      ></path>
    </SvgIcon>
  );
}
